import { LuxLink } from "@lux/atoms/components/LuxLink";
import { useRouter } from "next/router";
import React from "react";
import { ResponsiveBreakpoint } from "@lux/atoms/utils/StyleConstants";
import classNames from "classnames";
import {
  NftCollectionTab,
  useCollectionPageContext,
} from "./CollectionPageContext";
import { Solana } from "@glow/shared";

const TABS = [
  {
    type: NftCollectionTab.Nfts,
    text: "NFTs",
    path: "",
  },
  {
    type: NftCollectionTab.Sales,
    text: "Sales",
    path: "/sales",
  },
];

export const CollectionTabBar = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const { activeTab, emptyCollectionFilters, data } =
    useCollectionPageContext();
  const router = useRouter();
  const [nftCollectionSymbol] = router.query.nftCollectionSymbol as string[];

  const tabs = TABS.filter(
    (tab) =>
      tab.type !== NftCollectionTab.Sales ||
      data.collection.network === Solana.Network.Mainnet,
  );

  return (
    <div
      className={classNames("flex-baseline spread tab-bar", {
        "empty-filters": emptyCollectionFilters,
      })}
    >
      <div className="flex">
        {tabs.map((tab, tbx) => (
          <LuxLink
            key={tbx}
            href={`/collection/${nftCollectionSymbol}${tab.path}`}
            query={{ network: data.collection.network }}
            className={classNames("tab-nav mr-4 fw-bold animated", {
              active: activeTab === tab.type,
            })}
          >
            {tab.text}
          </LuxLink>
        ))}
      </div>
      <div>{children}</div>

      <style jsx>{`
        .tab-bar {
          border-bottom: 1px solid var(--divider-color);
          padding-bottom: 1rem;
          margin-left: calc(var(--sidebar-width) + var(--side-padding));
          height: 3.5rem;

          &.empty-filters {
            margin-left: 0;
          }

          @media (max-width: 1584px) {
            margin-left: 0;
          }

          :global(.tab-nav) {
            font-size: 1.5rem;
            margin: 0;
            color: var(--secondary-color);
          }

          :global(.tab-nav.active) {
            color: var(--primary-color);
          }

          @media (max-width: ${ResponsiveBreakpoint.medium}) {
            :global(.tab-nav) {
              font-size: 1.25rem;
            }
          }
        }
      `}</style>
    </div>
  );
};
